import _JSON$stringify from 'babel-runtime/core-js/json/stringify';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

import _ from 'lodash';
import SearchBar from '@/components/SearchV3';
import Pagination from '@/components/Pagination';
import TableList from '@/components/TableList';
import DemandDialog from './demand-dialog.vue';
import DcoDialog from './dco-dialog.vue';
import ActionsNameDialog from './actions-name-dialog.vue';
import previewModal from '@/components/PreviewModal';
import searchMixin from '@/mixin/search';
import { fetchCreativeMangeList, updateCreativeInfoAuth } from '@/api/creative/info';
import { getDmakerDcoDetail, previewDmakerTemplate, saveDmakerTemplate, activeDmakerTemplate } from '@/api/creative/template';
import copyCommonDialog from '../copyCommonDialog';
import CoverDialog from './cover-dialog.vue';
import CheckGmakerTemplate from './check-gmaker-template.vue';

var dcoConfigOption = [{
  value: 2,
  label: 'DCO配置'
}, {
  value: 1,
  label: '无DCO配置'
}];

import { categories } from '@/common/material-metadata';

export default {
  components: {
    SearchBar: SearchBar,
    Pagination: Pagination,
    TableList: TableList,
    previewModal: previewModal,
    DemandDialog: DemandDialog,
    DcoDialog: DcoDialog,
    copyCommonDialog: copyCommonDialog,
    CheckGmakerTemplate: CheckGmakerTemplate,
    CoverDialog: CoverDialog,
    ActionsNameDialog: ActionsNameDialog
  },
  mixins: [searchMixin],
  data: function data() {
    var searchField = [{
      value: 'demand_id',
      label: '需求ID'
    }, {
      value: 'id',
      label: '版本ID'
    }, {
      value: 'original_template_id',
      label: '创意方向ID'
    }, {
      value: 'name',
      label: '创意方向'
    }, {
      value: 'demand_name',
      label: '需求名称'
    }, {
      value: 'dco_ids',
      label: 'DCO ID'
    }, {
      value: 'basic_id',
      label: '基础包ID'
    }];

    return {
      query: {
        page: 1,
        page_size: 15,
        search_field: 'name',
        keyword: '',
        adv_ids: '',
        material_types: []
      },
      pagination: {
        total: 0
      },
      formItemList: [{
        type: 'select',
        prop: 'search_field',
        params: {
          clearable: true,
          disabled: false,
          readonly: false,
          placeholder: '请选择搜索字段',
          options: searchField
        }
      }, {
        type: 'input',
        prop: 'keyword',
        subtype: 'text',
        params: function params(_ref) {
          var formValue = _ref.formValue;

          return {
            clearable: true,
            placeholder: formValue.search_field ? searchField.find(function (item) {
              return item.value === formValue.search_field;
            }).label + '搜索' : '请输入搜索内容'
          };
        }
      }, {
        prop: 'adv_ids',
        type: 'business',
        subtype: 'advertiser-selector',
        params: {
          multiple: true,
          filterable: true,
          collapseTags: true,
          style: 'width: 220px;',
          class: 'search-filter-select'
        }
      }, {
        type: 'select',
        prop: 'material_types',
        params: {
          clearable: true,
          disabled: false,
          multiple: true,
          style: 'width: 220px;',
          collapseTags: true,
          readonly: false,
          placeholder: '请选择类型',
          options: categories
        }
      }, {
        type: 'select',
        prop: 'output_type',
        params: {
          clearable: true,
          placeholder: '是否DCO配置',
          style: 'width: 220px;',
          options: dcoConfigOption
        }
      }],
      list: [],
      listLoading: true,
      tableColumnConfig: [{
        label: '创意方向ID',
        prop: 'original_template_id',
        width: 100
      }, {
        label: '版本ID',
        prop: 'id',
        width: 90
      }, {
        slot: 'name-cell'
      }, {
        slot: 'thumbnail-cell'
      }, {
        slot: 'demand-cell'
      }, {
        slot: 'basic-cell'
      }, {
        label: 'DCO ID',
        prop: 'dco_ids',
        width: 120
      }, {
        slot: 'category-cell'
      }, {
        slot: 'createtime-cell'
      }, {
        slot: 'auth-cell'
      }, {
        slot: 'action-cell'
      }],
      dcoDialog: {
        visible: false,
        info: {},
        data: []
      },
      actionsDialog: {
        visible: false,
        type: 'action', // 埋点名称
        data: {},
        journeyData: {},
        panes: ['actions', 'journey']
      },
      previewDialog: {
        visible: false,
        title: '',
        showMwUrl: false,
        language: ''
      },
      previewLoading: true,
      demandDialog: {
        visible: false,
        title: '',
        status: '', // 创意方向模板状态
        list: []
      },
      coverDialog: {
        visible: false
      },
      copyTemplateDialogAttrs: {
        visible: false
      },
      templateInfo: {
        src_template_id: '',
        src_template_name: '',
        thumbnail: '',
        thumbnail_l: ''
      },
      editableTemplateForm: [],
      isProxyTemplate: false
    };
  },

  watch: {
    $route: function $route(to, from) {
      this.renderList(this.query);
    }
  },
  methods: {
    renderList: function renderList(params) {
      var _this = this;

      this.listLoading = true;
      fetchCreativeMangeList(params).then(function (res) {
        console.log(res);
        _this.listLoading = false;
        _this.list = (_.get(res, 'data.data.list') || []).map(function (item) {
          // 输出方式是 dco 时，才需要展示 dco_id
          if (item.dco_ids) return item;
          return _extends({}, item, {
            dco_ids: '-'
          });
        });
        _this.pagination.total = _.get(res, 'data.data.total');
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    setActionsName: function setActionsName(item, type) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var tempActions, key;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.actionsDialog.panes = ['actions', 'journey'];
                if (_this2.actionsDialog.panes.indexOf('journey') !== -1) {
                  tempActions = item.actions ? _extends({}, item.actions) : {};

                  for (key in tempActions) {
                    tempActions[key] = tempActions[key]['zh-cn'];
                  }
                  _this2.actionsDialog.journeyData = {
                    actionNameDictionary: tempActions,
                    user_journeys: item.user_journeys
                  };
                }
                _this2.actionsDialog.data = item;
                _this2.actionsDialog.type = type; // 1.埋点名称 2.用户旅程
                _this2.actionsDialog.visible = true;

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    handleUpdateTab: function handleUpdateTab(type) {
      this.actionsDialog.type = type;
    },
    handleSetActionName: function handleSetActionName(data) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var postData;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                postData = {};

                if (_this3.actionsDialog.panes.indexOf('journey') !== -1) {
                  postData.user_journeys = _JSON$stringify(data.journey);
                }
                if (_this3.actionsDialog.panes.indexOf('actions') !== -1) {
                  postData.actions = _JSON$stringify(data.actions);
                }
                _context2.next = 5;
                return saveDmakerTemplate({
                  template_id: _this3.actionsDialog.data.id
                }, postData);

              case 5:
                _this3.renderList(_this3.query);

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    handleClickReport: function handleClickReport(item) {
      this.$router.push({
        name: 'report.creative.dco',
        query: {
          creative_name: item.name
        }
      });
    },
    handleChangeAuth: function handleChangeAuth(data) {
      var _this4 = this;

      this.listLoading = true;
      updateCreativeInfoAuth({
        id: data.id,
        permission: data.is_makable
      }).then(function (res) {
        _this4.listLoading = false;
        _this4.renderList(_this4.query);
      }).catch(function () {
        _this4.listLoading = false;
      });
    },
    showCreativeDialog: function showCreativeDialog(data) {
      this.demandDialog.visible = true;
      this.demandDialog.status = data.status;
      this.demandDialog.enable_i18n = data.enable_i18n;
      this.demandDialog.list = (data.demand_info || []).map(function (item) {
        return _extends({}, item, {
          creative_id: data.id
        });
      });
    },
    previewPA: function previewPA(obj) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var previewUrl;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this5.previewLoading = true;
                _this5.previewDialog = {
                  visible: true,
                  title: obj.name,
                  language: ''
                  // 判断是否有语言包
                };if (obj.language) {
                  _this5.previewDialog.language = obj.language;
                }
                _context3.prev = 3;
                _context3.t0 = _;
                _context3.next = 7;
                return previewDmakerTemplate({ id: obj.id });

              case 7:
                _context3.t1 = _context3.sent;
                previewUrl = _context3.t0.get.call(_context3.t0, _context3.t1, 'data.data.preview_url');

                _this5.previewDialog = _extends({}, _this5.previewDialog, {
                  html_url: previewUrl
                });
                _this5.previewLoading = false;
                _context3.next = 17;
                break;

              case 13:
                _context3.prev = 13;
                _context3.t2 = _context3['catch'](3);

                _this5.previewLoading = false;
                _this5.$message(_JSON$stringify(_context3.t2));

              case 17:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5, [[3, 13]]);
      }))();
    },

    // 查看详情
    showDcoRenderDialog: function showDcoRenderDialog(row) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var res, info;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return getDmakerDcoDetail({ creative_id: row.id });

              case 2:
                res = _context4.sent;
                info = _.pick(res.data.data.dco_info, ['id', 'name', 'updated_time', 'finishes', 'total', 'status']);

                info.name = _.get(res.data.data.info, 'name') || '';
                // 复制组合数
                try {
                  info.groups = JSON.parse(_.get(res.data.data, 'dco_creatives')[0].groups).length;
                } catch (e) {
                  info.groups = 0;
                }
                _this6.dcoDialog.info = info;
                _this6.dcoDialog.data = _this6.cookCreatives(_.get(res.data.data, 'dco_creatives')) || [];
                _this6.dcoDialog.visible = true;

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6);
      }))();
    },
    cookCreatives: function cookCreatives(list) {
      var temp = [];
      if (list.length) {
        list.map(function (i) {
          JSON.parse(i.groups).map(function (k) {
            var item = _extends({}, i);
            item.gid = k.gid;
            item.dco_ids = item.id;
            delete item.id;
            temp.push(item);
          });
        });
        //
      }
      return temp;
    },
    updatePreviewDialog: function updatePreviewDialog(item) {
      this.previewPA({
        name: '渲染预览',
        tpl_html_url: '' + item.preview_url + (item.preview_url.indexOf('?') !== -1 ? '&' : '?') + 'dco_gid=' + item.gid || ''
      });
    },
    showCopyDialog: function showCopyDialog(item, type) {
      this.setDialogTemplateInfo(item);
      this.copyTemplateDialogAttrs.visible = true;
      // 复制为代理模版只有 名称和是否开放小游戏原生试玩可编辑；
      if (type === 'proxy') {
        this.isProxyTemplate = true;
        this.editableTemplateForm = ['name', 'name_en', 'enable_wxgame'];
      } else {
        this.isProxyTemplate = false;
        this.editableTemplateForm = [];
      }
    },
    setDialogTemplateInfo: function setDialogTemplateInfo(item) {
      this.templateInfo.src_template_id = item.id;
      this.templateInfo.src_template_name = item.name;
      this.templateInfo.thumbnail = item.thumbnail || ''; // 竖屏
      this.templateInfo.thumbnail_l = item.thumbnail_l || ''; // 横屏
    },
    handleCreateSuccess: function handleCreateSuccess() {
      var pathName = '';
      if (this.isProxyTemplate) {
        pathName = 'producer.template-management.proxyTemplate';
      } else {
        pathName = 'producer.template-management.library';
      }
      this.$router.push({
        name: pathName
      });
    },
    showCoverDialog: function showCoverDialog(row) {
      this.setDialogTemplateInfo(row);
      this.coverDialog.visible = true;
    },

    // 创意方向上线
    handleClickOnline: function handleClickOnline(id) {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var res;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return activeDmakerTemplate(id);

              case 3:
                res = _context5.sent;

                if (res.data.code === 0) {
                  _this7.renderList(_this7.query);
                }
                _context5.next = 10;
                break;

              case 7:
                _context5.prev = 7;
                _context5.t0 = _context5['catch'](0);

                console.log(_context5.t0);

              case 10:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this7, [[0, 7]]);
      }))();
    },
    handleUpdateCover: function handleUpdateCover() {
      this.renderList(this.query);
    },

    // 复制为待制作模版
    handleClickCopyModel: function handleClickCopyModel() {}
  },
  mounted: function mounted() {
    this.renderList(this.query);
  }
};